export const iconFontAwesomeTravelHotelRoadBarrier = (
	<i className="fa-solid fa-road-barrier"></i>
);
